<template>
  <div class="status-card status-thankyou">
    <div class="status-header">
      <div class="status-icon-wrapper thankyou">
        <img
          alt="thank you"
          width="48px"
          :src="waitingVerifyImg"
        >
      </div>
      <h3 class="status-title">
        Cảm ơn bạn đã gửi thông tin
      </h3>
    </div>

    <div class="status-content">
      <div class="status-description">
        <feather-icon
          icon="CheckCircleIcon"
          size="20"
          class="status-description-icon"
        />
        <span>{{ thankYouMessage }}</span>
      </div>

      <div class="action-buttons">
        <btn-loading
          variant-convert="btn-back"
          @click.prevent="goBack"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="ChevronLeftIcon"
              size="16"
              class="mr-1"
            />
            <span>Quay lại bước trước</span>
          </div>
        </btn-loading>
        <btn-loading
          variant-convert="btn-submit"
          pill
          @click.prevent="goToAddFund"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="PlusCircleIcon"
              size="16"
              class="mr-1"
            />
            <span>Nạp tiền</span>
          </div>
        </btn-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import envMixin from '@/mixins/envMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { V_CONTRACT_STATUS } from '@/constants/contractVerification'
import iconWaitingVerifyEmedia from '@/assets/images/pages/adsAccount/icon-waiting-verify-emedia.svg'
import iconHeartSuccess from '@/assets/images/pages/adsAccount/icon-heart-success.png'

const { mapGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapGettersContract } = createNamespacedHelpers('contract')

export default {
  name: 'ThankYouStatus',

  components: {
    BtnLoading,
  },

  mixins: [stepGuideMixin, envMixin],

  computed: {
    ...mapGetters(['user']),
    ...mapGettersContract({
      contract: 'contract',
    }),

    waitingVerifyImg() {
      if (this.isEmediaPlatform) {
        return iconWaitingVerifyEmedia
      }
      return iconHeartSuccess
    },

    thankYouMessage() {
      // Hiển thị message dựa trên trạng thái contract
      const contractFinished = this.contract?.contract?.status === V_CONTRACT_STATUS.FINISHED
      if (contractFinished) {
        return 'Hoàn thành các bước xác minh'
      }
      return 'Thông tin của bạn đã được xác minh!'
    },
  },

  methods: {
    goBack() {
      this.$router.push('/update-information')
    },

    goToAddFund() {
      if (this.isOnlyEcomdyPlatform) {
        this.$router.push('/payment/add-fund?tab=paypal')
      } else {
        this.$router.push('/payment/add-fund')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.status-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;

  @media(max-width: 767px) {
    padding: 24px;
    border-radius: 12px;
  }
}

.status-header {
  text-align: center;
  margin-bottom: 28px;
}

.status-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    display: block;
    margin: 0 auto;
  }

  &.thankyou {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
  }
}

.status-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 20px;
  }
}

.status-content {
  text-align: left;
}

.status-description {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  line-height: 1.6;
  color: #1f2937;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 500;

  @media(max-width: 767px) {
    font-size: 14px;
    margin-bottom: 24px;
    gap: 6px;
  }

  .status-description-icon {
    color: #4cb375;
    flex-shrink: 0;
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
  align-items: stretch;

  @media(min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 40px;
  }

  :deep(.btn-loading) {
    min-width: 200px;
    width: 100%;

    @media(min-width: 768px) {
      width: auto;
      min-width: 180px;
    }
  }
}
</style>
